import React from "react";
import { SiteTable } from "@/components";
import { SiteType } from "@/types";
import { Badge } from "@oreme/ui";
import { useTranslations } from "next-intl";

type MissionSitesProps = {
  sites: SiteType[];
};

function MissionSites({ sites }: Readonly<MissionSitesProps>) {
  const t = useTranslations("mission.MissionSites");
  if (!sites || sites.length === 0) return null;

  return (
    <div className="border-t">
      <header className="flex flex-row justify-between items-center p-4 pb-0">
        <h4 className="text-xs font-semibold uppercase text-muted-foreground">
          {t("title")}
        </h4>
        <Badge variant="secondary">{sites.length}</Badge>
      </header>
      <div className="p-4 w-full">
        <div className="border rounded overflow-hidden">
          <SiteTable data={sites} />
        </div>
      </div>
    </div>
  );
}

export { MissionSites };
